// SarData.js
import useSWR from 'swr';

const fetcher = (url) => fetch(url).then(res => res.json());

export function useSarSitesData() {
  const { data, error } = useSWR('/data/sar_sites.json', fetcher, {
    revalidateOnFocus: false,
    refreshInterval: 0,
  });

  return {
    sites: data?.data ?? [],
    count: data?.count ?? 0,
    fetchedAt: data?.timestamp ?? null,
    isLoading: !data && !error,
    isError: !!error,
  };
}

export function useSarDetectionsData() {
  const { data, error } = useSWR('/data/sar_detections.json', fetcher, {
    revalidateOnFocus: false,
    refreshInterval: 0,
  });

  return {
    detections: data?.data ?? [],
    fetchedAt: data?.timestamp ?? null,
    count: data?.count ?? 0,
    isLoading: !data && !error,
    isError: !!error,
  };
}